<div class="content-management-container">
  <p-accordion class="custom-accordion" (onOpen)="onAccordionOpen($event)">
    <p-accordionTab *ngFor="let section of sections" [header]="section.label">
      <div class="editor-wrapper">
        <quill-editor
          [(ngModel)]="section.content"
          [modules]="quillModules"
          [styles]="{ 'font-family': 'Montserrat, sans-serif', 'font-size': '12px' }"
          (onEditorCreated)="onEditorCreated($event)"
          (onContentChanged)="onContentChanged(section, $event)"
          placeholder="Start typing here..."
        ></quill-editor>
        <div class="action-buttons">
          <button
            pButton
            type="button"
            icon="pi pi-undo"
            label="Undo"
            class="p-button-secondary p-button-sm"
            pTooltip="Undo (Ctrl+Z)"
            tooltipPosition="top"
            [disabled]="!section.isDirty"
            (click)="onUndo(section)"
          ></button>
          <button
            pButton
            type="button"
            icon="pi pi-save"
            label="Save"
            class="p-button-success p-button-sm"
            pTooltip="Save changes"
            tooltipPosition="top"
            [disabled]="!section.isDirty"
            (click)="onSave(section)"
          ></button>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>

